import request from '@/api/request';

// 获取根栏目下所有文章
export function getBannerList(id) {
  return request({
    url: '/hk-api/banners?cateId=' + id,
    method: 'get'
  })
}
// 获取首页产品推荐列表
export function getProductList() {
  return request({
    url: '/hk-api/products/recommends',
    method: 'get'
  })
}
// 获取首页会议推荐列表
export function getEventList() {
  return request({
    url: '/hk-api/event-hub',
    method: 'get'
  })
}
// 获取列表页筛选项
export function getFilterList(type) {
  return request({
    url: '/hk-api/products/options?product=' + type,
    method: 'get'
  })
}
// 获取列表页产品列表
export function getListProductList(data) {
  return request({
    url: '/hk-api/products',
    method: 'post',
    data
  })
}
// 获取列表页choose
export function getListChoose(type) {
  return request({
    url: '/hk-api/products/accessory?product=' + type,
    method: 'get'
  })
}
// 搜索列表
export function getSearchListData (params) {
  return request({
    url: '/hk-api/search-new',
    method: 'get',
    params
  })
}
// 获取产品详情
export function getProductDetail(id) {
  return request({
    url: '/hk-api/products/detail?id=' + id,
    method: 'get'
  })
}
// 获取详情页推荐产品
export function getProductRecommend(id) {
  return request({
    url: '/hk-api/products/related?id=' + id,
    method: 'get'
  })
}
// 发邮件
export function sendEmail(data) {
  return request({
    url: '/api/edm/register/notice',
    method: 'post',
    data
  })
}
// 获取产品促销页内容
export function getCampaignContent() {
  return request({
    url: '/hk-api/campaign/laptop?v=0.2',
    method: 'get'
  })
}